import { Parsing } from "./parsing";

class SkHtml extends Parsing {
  exp: any;
  constructor(
    private elem: HTMLElement,
    private attr: string,
    private module: any
  ) {
    super();
    this.exp = Parsing.expression(attr);
    this.update();
  }

  update(): void {
    const value = this.exp.call(this.module);
    this.elem.innerHTML = value || "";
  }
}

export { SkHtml };
